const Ls5BronquiolitisSintomas = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>¿Cu&aacute;les son los s&iacute;ntomas de la <span className='titulo--lesson--color--2'> bronquiolitis? </span></h1>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Los s&iacute;ntomas de la bronquiolitis, causada m&aacute;s com&uacute;nmente por el <span className="texto--span">VSR,</span> pueden empezar con un resfriado com&uacute;n e incluir:</p>
                    </div>

                    <div className="container text-center">
                        <div className="row text-center gap-1 ps-4 texto--burbuja--bold align-items-center">
                            <div className="col-3 style--burbuja">
                                <p className="my-2">Fiebre</p>
                            </div>
                            <div className="col-3 style--burbuja">
                                <p className="my-2">Tos seca</p>
                            </div>
                            <div className="col-5 style--burbuja">
                                <p className="my-2">Congesti&oacute;n nasal</p>
                            </div>
                        </div>
                    </div>

                    <h1 className="text--subtitulo p-4">Bronquiolitis</h1>

                    <div className='container pt-0 px-4'>
                        <p className='texto--parrafo'>Los s&iacute;ntomas pueden empeorar a medida que el virus se propaga en los pulmones y pueden incluir:</p>
                    </div>

                    <div className='container'>
                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Nose.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>Respiraci&oacute;n r&aacute;pida</p>
                            </div>
                        </div>

                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Costillas.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>Tiraje costal (hundimiento anormal de las costillas al inspirar)</p>
                            </div>
                        </div>

                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Termometro.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>Temperatura anormalmente alta o baja (Menor que 35,5°C o mayor que 37,5°C)</p>
                            </div>
                        </div>

                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Tetero.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>No se alimenta</p>
                            </div>
                        </div>

                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Baby.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>No hay movimientos</p>
                            </div>
                        </div>

                        <div className='row d-flex'>
                            <div className='col-2 px-3'>
                                <img src="./img/Ls5Colvulsiones.png" className='text-center p-3' />
                            </div>
                            <div className='col-10 p-3'>
                                <p className='texto--parrafo margin--burbujas'>Convulsiones</p>
                            </div>
                        </div>
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja lh-1 ps-lg-3 ps-xl-5 m-0'>En caso de presentarse cualquiera de estos s&iacute;ntomas, consulte inmediatamente a su m&eacute;dico/a.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>VSR: virus sincitial respiratorio. <br />
                            Adaptado de <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/bronchiolitis/basics/symptoms/con-20019488'>http://www.mayoclinic.org/diseases-conditions/bronchiolitis/basics/symptoms/con-20019488</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls5BronquiolitisSintomas;